/*
 * Hadrone Supply - Wishlist Feature
 * localStorage-based wishlist with Web Component heart buttons
 */

/* --- Wishlist Data Store --- */
window.HadroneWishlist = {
  STORAGE_KEY: 'hadrone_wishlist',

  getItems() {
    try {
      const items = JSON.parse(localStorage.getItem(this.STORAGE_KEY)) || [];
      return items.map(function (item) {
        if (typeof item === 'string') return { id: item, handle: '' };
        return item;
      });
    } catch (e) {
      return [];
    }
  },

  addItem(productId, handle) {
    const items = this.getItems();
    const id = String(productId);
    if (!items.find(function (item) { return item.id === id; })) {
      items.push({ id: id, handle: handle || '' });
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(items));
      if (typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.wishlistUpdate, { productId: id, action: 'add' });
      }
    }
  },

  removeItem(productId) {
    const id = String(productId);
    const items = this.getItems().filter(function (item) { return item.id !== id; });
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(items));
    if (typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.wishlistUpdate, { productId: id, action: 'remove' });
    }
  },

  hasItem(productId) {
    return this.getItems().some(function (item) { return item.id === String(productId); });
  },

  getCount() {
    return this.getItems().length;
  }
};

/* --- Wishlist Button Web Component --- */
if (!customElements.get('wishlist-button')) {
  class WishlistButton extends HTMLElement {
    connectedCallback() {
      this.productId = this.dataset.productId;
      this.productHandle = this.dataset.productHandle || '';
      this.btn = this.querySelector('button');
      if (!this.btn) return;

      this.btn.addEventListener('click', this.toggle.bind(this));
      this.unsubscribe = typeof subscribe === 'function'
        ? subscribe(PUB_SUB_EVENTS.wishlistUpdate, this.syncState.bind(this))
        : null;
      this.syncState();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    toggle(e) {
      e.preventDefault();
      e.stopPropagation();
      if (HadroneWishlist.hasItem(this.productId)) {
        HadroneWishlist.removeItem(this.productId);
      } else {
        HadroneWishlist.addItem(this.productId, this.productHandle);
      }
    }

    syncState() {
      if (!this.btn) return;
      const active = HadroneWishlist.hasItem(this.productId);
      this.btn.classList.toggle('wishlist-btn--active', active);
      this.btn.setAttribute('aria-pressed', active);
      this.btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');

      const textEl = this.btn.querySelector('.pdp-wishlist-text');
      if (textEl) {
        textEl.textContent = active ? 'Saved to Wishlist' : 'Add to Wishlist';
      }
    }
  }

  customElements.define('wishlist-button', WishlistButton);
}

/* --- Header Badge Count --- */
function updateWishlistBadge() {
  var badge = document.querySelector('.wishlist-count-bubble');
  if (!badge) return;
  var count = HadroneWishlist.getCount();
  if (count > 0) {
    badge.textContent = count;
    badge.hidden = false;
  } else {
    badge.hidden = true;
  }
}

document.addEventListener('DOMContentLoaded', updateWishlistBadge);
if (typeof subscribe === 'function') {
  subscribe(PUB_SUB_EVENTS.wishlistUpdate, updateWishlistBadge);
}
